import GaussIcon from '../Icons/GaussIcon';
import NewtonIcon from '../Icons/NewtonIcon';
import InterpolationIcon from '../Icons/InterpolationIcon';
import LinearFitIcon from '../Icons/LinearFitIcon';
import DecompositionIcon from '../Icons/DecompositionIcon';
import IterativeLinearSolversIcon from '../Icons/InterativeLinearSolversIcon';
import QuadratureIcon from '../Icons/QuadratureIcon';
import SimplexIcon from '../Icons/SimplexIcon';

export const METHOD_DEFINITIONS = [
  {
    id: 'gauss',
    name: 'Gaussian Elimination',
    description:
      'Solve linear systems through row operations and back substitution.',
    color: '#5b7cff',
    icon: <GaussIcon size={42} />,
  },
  {
    id: 'newton',
    name: "Newton's Method",
    description:
      'Iteratively solve nonlinear problems with Newton\'s method.',
    color: '#16a34a',
    icon: <NewtonIcon size={42} />,
  },
  {
    id: 'interpolation',
    name: 'Interpolation',
    description:
      'Build smooth curves through data points with polynomials or splines.',
    color: '#c084fc',
    icon: <InterpolationIcon size={42} />,
  },
  {
    id: 'linearfit',
    name: 'Polynomial Fit',
    description:
      'Estimate best fit models with polynomials.',
    color: '#facc15',
    icon: <LinearFitIcon size={42} />,
  },
  {
    id: 'decomposition',
    name: 'Matrix Decomposition',
    description:
      'Compute LU, QR, Cholesky and Singular Value Decompositions.',
    color: '#fb7185',
    icon: <DecompositionIcon size={42} />,
  },
  {
    id: 'iterlinsolve',
    name: 'Iterative Linear Solvers',
    description:
      'Solve linear systems iteratively with Gauss–Seidel, CG, and more.',
    color: '#38bdf8',
    icon: <IterativeLinearSolversIcon size={42} />,
  },
  {
    id: 'simplex',
    name: 'Simplex Algorithm',
    description:
      'Solve linear programs with the Simplex algorithm.',
    color: '#ef4444',
    icon: <SimplexIcon size={42} />,
  },
  {
    id: 'quadrature',
    name: 'Quadrature',
    description:
      'Approximate definite integrals with Quadrature rules.',
    color: '#0d9488',
    icon: <QuadratureIcon size={42} />,
  },
];
